module.exports = __webpack_public_path__ + "f576f36d9e440488d603907d497f91dc.svg";